import React from "react";
import majeticWater from "../../assets/images/webp/other/majetic-water-img.webp";
import { MAGNETIC_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";

const InjkWater = () => {
  return (
    <>
      <div className="px-4">
        <div className="flex items-center justify-between mx-auto max-md:flex-wrap max-w-[1140px] max-md:gap-6">
          <div className="w-full max-w-[509px] max-md:max-w-full">
            <BlueTag>Magnetic Water</BlueTag>
            <Heading> INJK Magnetic Water Device</Heading>
            <div className="pt-5">
              {MAGNETIC_LIST.map((obj, i) => (
                <div
                  className={`flex items-center gap-2 ${
                    i !== MAGNETIC_LIST.length - 1 && "mb-4"
                  }`}
                  key={i}
                >
                  <Icons icon="CheckIcon" />
                  <p className="text-custom-dark-blue text-sm font-semibold leading-150 lg:leading-[19.31px]">
                    {obj}
                  </p>
                </div>
              ))}
            </div>
            <p className="pt-6 text-custom-dark-blue text-base md:text-lg font-bold leading-[150%] ff-jakarta">
              Used by 10,000+ people worldwide
            </p>
          </div>
          <div className="w-full max-w-[469px] max-md:mx-auto max-md:max-[550px]">
            <img
              src={majeticWater}
              alt="magnetic-water"
              width={469}
              height={333}
              className="w-full object-contain"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default InjkWater;
